import NewOpportunity from "./NewOpportunity";

export default NewOpportunity;
